class HelpButtonController {
  constructor(HelpService, $state, $rootScope) {
    'ngInject';
    this.HelpService = HelpService;
    this.$state = $state;
    this.$rootScope = $rootScope;
    this.stateChangeListener = null;
  }

  $onInit() {
    this.resolveTopic();
    this.stateChangeListener = this.$rootScope.$on('$stateChangeSuccess', () => {
      if (!this.topic) {
        this.resolveTopic();
      }
    });
  }

  $onChanges() {
    this.resolveTopic();
  }

  $onDestroy() {
    if (this.stateChangeListener) {
      this.stateChangeListener();
    }
  }

  resolveTopic() {
    if (this.topic) {
      this.resolvedTopic = this.HelpService.getTopic(this.topic);
    } else {
      this.resolvedTopic = this.HelpService.getTopicForState();
    }
  }

  isVisible() {
    if (this.browse === 'true' || this.browse === true) {
      return true;
    }
    if (!this.resolvedTopic) {
      return false;
    }
    return this.HelpService.canAccessTopic(this.resolvedTopic);
  }

  getTitle() {
    if (this.label) {
      return this.label;
    }
    if (this.resolvedTopic) {
      return 'Help: ' + this.resolvedTopic.title;
    }
    return 'Help';
  }

  openHelp() {
    if (this.browse === 'true' || this.browse === true) {
      this.HelpService.openBrowser();
      return;
    }
    this.HelpService.open(this.topic || undefined);
  }
}

export default HelpButtonController;



// WEBPACK FOOTER //
// ./client/help/help-button/help-button.controller.js